// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Signup_container__gL8ZF{
    display: flex;
    flex-direction: row-reverse;
    height: 100%;
    padding-top: 30px;
}
.Signup_banner__ytatJ{
    height: calc(100vh - 154px);
    width: 40%;
    padding-bottom: 50px;
}
@media(max-width: 1080px){
    .Signup_container__gL8ZF{
        display: block;
        height: auto;
    }
    .Signup_banner__ytatJ{
        display: flex;
        flex-direction: column-reverse;
        width: 100%;
        margin-top: -25px;
    }
}
@media(max-width: 600px){
    .Signup_container__gL8ZF{
        padding-top: 0;
    }
    .Signup_banner__ytatJ{
        margin-top: -60px;
    }
}
.Signup_bottomBar__uVWbh{
    display: flex;
    align-items: center;
    margin-top: -5px;
    padding: 20px 25px 20px 30px;
    background-color: #40798C;
    border-radius: 0 0 30px 30px;
}
@media(max-width: 1080px){
    .Signup_bottomBar__uVWbh{
        margin-top: -5px;
        padding-bottom: 50px;
        border-radius: 30px 30px 0 0;
    }
}
@media(max-width: 450px){
    .Signup_bottomBar__uVWbh{
        flex-direction: column;
        padding: 25px 25px 60px 25px;
    }
}
.Signup_bottomBarText__lSQ5Y{
    margin-right: 25px;
    font-size: 31px;
    color: #FFFFFF;
    line-height: 31px;
}
.Signup_image__gge25{
    height: calc(100% - 88px);
    width: 100%;
    border-radius: 30px 30px 0 0;
    object-fit: cover;
}
@media(max-width: 1080px){
    .Signup_image__gge25{
        margin-top: -30px;
    }
}
.Signup_loginButton__IMjHJ{
    margin-left: auto;
}
@media(max-width: 450px){
    .Signup_loginButton__IMjHJ{
        width: calc(100% - 90px);
        margin-top: 20px;
    }
}
.Signup_formContainer__w0d5c{
    display: flex;
    justify-content: center;
    height: calc(100vh - 154px);
    width: 60%;
    padding-top: 15px;
    overflow-y: auto;
}
@media(max-width: 1080px){
    .Signup_formContainer__w0d5c{
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
        height: auto;
        min-height: 750px;
        width: 500px;
        padding-top: 0;
    }
}
@media(max-width: 600px){
    .Signup_formContainer__w0d5c{
        width: calc(100% - 30px);
        margin: 0 15px 90px 15px;
        overflow-y: visible;
    }
}
.Signup_form__RyeZ1{
    width: 500px;
    margin-bottom: 50px;
}
@media(max-width: 600px){
    .Signup_form__RyeZ1{
        width: 100%;
    }
}
@media(max-width: 600px){
    .Signup_header__O2IdY{
        margin-bottom: 30px;
    }
}
@media(max-width: 530px){
    .Signup_header__O2IdY{
        text-align: left !important;
    }
}
.Signup_formRadioButtonsRow__WsFxL{
    display: flex;
    margin-bottom: 35px;
}
.Signup_radioButton__0GrqQ{
    width: 222px;
}
.Signup_radioButton__0GrqQ:first-child{
    margin-right: 22px;
}
@media(max-width: 600px){
    .Signup_formRadioButtonsRow__WsFxL{
        display: block;
        margin-bottom: 25px;
    }
    .Signup_radioButton__0GrqQ{
        width: calc(100% - 30px) !important;
        margin-bottom: 12px;
    }
}
.Signup_dualInputsRow__eoWsi{
    display: flex;
}
.Signup_halfLineInput__rsiQI{
    margin-top: 15px;
}
.Signup_halfLineInput__rsiQI:last-child{
    margin-left: auto;
}
.Signup_halfLineInput__rsiQI input{
    width: 190px;
}
.Signup_halfLineInput__rsiQI select{
    width: 238px;
}
.Signup_singleLineInput__r2YoA{
    display: block !important;
    margin-top: 15px;
}
.Signup_singleLineInput__r2YoA input{
    width: calc(100% - 40px);
}
@media(max-width: 600px){
    .Signup_dualInputsRow__eoWsi{
        display: block;
    }
    .Signup_halfLineInput__rsiQI{
        display: block !important;
    }
    .Signup_halfLineInput__rsiQI input{
        width: calc(100% - 45px);
    }
    .Signup_halfLineInput__rsiQI select{
        width: calc(100% + 3px);
    }
    .Signup_singleLineInput__r2YoA input{
        width: calc(100% - 45px);
    }
}
.Signup_consent__\\+JMCd{
    width: 100%;
    margin-top: 40px;
    color: #1F363D;
    text-align: center;
    font-size: 14px;
}
.Signup_consent__\\+JMCd a{
    color: #40798C;
    font-family: 'Gotham Medium', serif;
    text-decoration: none;
}
.Signup_consent__\\+JMCd a{
    color: #40798C;
    font-family: 'Gotham Medium', serif;
    text-decoration: none;
}
.Signup_consent__\\+JMCd a:focus-visible{
    outline: none;
}
.Signup_button__IsHPR{
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Signup.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,2BAA2B;IAC3B,UAAU;IACV,oBAAoB;AACxB;AACA;IACI;QACI,cAAc;QACd,YAAY;IAChB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,WAAW;QACX,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI;QACI,gBAAgB;QAChB,oBAAoB;QACpB,4BAA4B;IAChC;AACJ;AACA;IACI;QACI,sBAAsB;QACtB,4BAA4B;IAChC;AACJ;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,4BAA4B;IAC5B,iBAAiB;AACrB;AACA;IACI;QACI,iBAAiB;IACrB;AACJ;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,wBAAwB;QACxB,gBAAgB;IACpB;AACJ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,UAAU;IACV,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI;QACI,OAAO;QACP,QAAQ;QACR,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,iBAAiB;QACjB,YAAY;QACZ,cAAc;IAClB;AACJ;AACA;IACI;QACI,wBAAwB;QACxB,wBAAwB;QACxB,mBAAmB;IACvB;AACJ;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,2BAA2B;IAC/B;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;IACA;QACI,mCAAmC;QACnC,mBAAmB;IACvB;AACJ;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,cAAc;IACd,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,mCAAmC;IACnC,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".container{\n    display: flex;\n    flex-direction: row-reverse;\n    height: 100%;\n    padding-top: 30px;\n}\n.banner{\n    height: calc(100vh - 154px);\n    width: 40%;\n    padding-bottom: 50px;\n}\n@media(max-width: 1080px){\n    .container{\n        display: block;\n        height: auto;\n    }\n    .banner{\n        display: flex;\n        flex-direction: column-reverse;\n        width: 100%;\n        margin-top: -25px;\n    }\n}\n@media(max-width: 600px){\n    .container{\n        padding-top: 0;\n    }\n    .banner{\n        margin-top: -60px;\n    }\n}\n.bottomBar{\n    display: flex;\n    align-items: center;\n    margin-top: -5px;\n    padding: 20px 25px 20px 30px;\n    background-color: #40798C;\n    border-radius: 0 0 30px 30px;\n}\n@media(max-width: 1080px){\n    .bottomBar{\n        margin-top: -5px;\n        padding-bottom: 50px;\n        border-radius: 30px 30px 0 0;\n    }\n}\n@media(max-width: 450px){\n    .bottomBar{\n        flex-direction: column;\n        padding: 25px 25px 60px 25px;\n    }\n}\n.bottomBarText{\n    margin-right: 25px;\n    font-size: 31px;\n    color: #FFFFFF;\n    line-height: 31px;\n}\n.image{\n    height: calc(100% - 88px);\n    width: 100%;\n    border-radius: 30px 30px 0 0;\n    object-fit: cover;\n}\n@media(max-width: 1080px){\n    .image{\n        margin-top: -30px;\n    }\n}\n.loginButton{\n    margin-left: auto;\n}\n@media(max-width: 450px){\n    .loginButton{\n        width: calc(100% - 90px);\n        margin-top: 20px;\n    }\n}\n.formContainer{\n    display: flex;\n    justify-content: center;\n    height: calc(100vh - 154px);\n    width: 60%;\n    padding-top: 15px;\n    overflow-y: auto;\n}\n@media(max-width: 1080px){\n    .formContainer{\n        left: 0;\n        right: 0;\n        margin-left: auto;\n        margin-right: auto;\n        height: auto;\n        min-height: 750px;\n        width: 500px;\n        padding-top: 0;\n    }\n}\n@media(max-width: 600px){\n    .formContainer{\n        width: calc(100% - 30px);\n        margin: 0 15px 90px 15px;\n        overflow-y: visible;\n    }\n}\n.form{\n    width: 500px;\n    margin-bottom: 50px;\n}\n@media(max-width: 600px){\n    .form{\n        width: 100%;\n    }\n}\n@media(max-width: 600px){\n    .header{\n        margin-bottom: 30px;\n    }\n}\n@media(max-width: 530px){\n    .header{\n        text-align: left !important;\n    }\n}\n.formRadioButtonsRow{\n    display: flex;\n    margin-bottom: 35px;\n}\n.radioButton{\n    width: 222px;\n}\n.radioButton:first-child{\n    margin-right: 22px;\n}\n@media(max-width: 600px){\n    .formRadioButtonsRow{\n        display: block;\n        margin-bottom: 25px;\n    }\n    .radioButton{\n        width: calc(100% - 30px) !important;\n        margin-bottom: 12px;\n    }\n}\n.dualInputsRow{\n    display: flex;\n}\n.halfLineInput{\n    margin-top: 15px;\n}\n.halfLineInput:last-child{\n    margin-left: auto;\n}\n.halfLineInput input{\n    width: 190px;\n}\n.halfLineInput select{\n    width: 238px;\n}\n.singleLineInput{\n    display: block !important;\n    margin-top: 15px;\n}\n.singleLineInput input{\n    width: calc(100% - 40px);\n}\n@media(max-width: 600px){\n    .dualInputsRow{\n        display: block;\n    }\n    .halfLineInput{\n        display: block !important;\n    }\n    .halfLineInput input{\n        width: calc(100% - 45px);\n    }\n    .halfLineInput select{\n        width: calc(100% + 3px);\n    }\n    .singleLineInput input{\n        width: calc(100% - 45px);\n    }\n}\n.consent{\n    width: 100%;\n    margin-top: 40px;\n    color: #1F363D;\n    text-align: center;\n    font-size: 14px;\n}\n.consent a{\n    color: #40798C;\n    font-family: 'Gotham Medium', serif;\n    text-decoration: none;\n}\n.consent a{\n    color: #40798C;\n    font-family: 'Gotham Medium', serif;\n    text-decoration: none;\n}\n.consent a:focus-visible{\n    outline: none;\n}\n.button{\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 40px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Signup_container__gL8ZF`,
	"banner": `Signup_banner__ytatJ`,
	"bottomBar": `Signup_bottomBar__uVWbh`,
	"bottomBarText": `Signup_bottomBarText__lSQ5Y`,
	"image": `Signup_image__gge25`,
	"loginButton": `Signup_loginButton__IMjHJ`,
	"formContainer": `Signup_formContainer__w0d5c`,
	"form": `Signup_form__RyeZ1`,
	"header": `Signup_header__O2IdY`,
	"formRadioButtonsRow": `Signup_formRadioButtonsRow__WsFxL`,
	"radioButton": `Signup_radioButton__0GrqQ`,
	"dualInputsRow": `Signup_dualInputsRow__eoWsi`,
	"halfLineInput": `Signup_halfLineInput__rsiQI`,
	"singleLineInput": `Signup_singleLineInput__r2YoA`,
	"consent": `Signup_consent__+JMCd`,
	"button": `Signup_button__IsHPR`
};
export default ___CSS_LOADER_EXPORT___;
